export function stringMask(text: string, maxLength = 12, mask = '*', first = 2, last = 4): string {
  return (
    text.slice(0, first) +
    text
      .slice(text.length <= first + last ? text.length : -last)
      .padStart(Math.min(text.length, maxLength - first) - first, mask)
  );
}
